/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import { Checkbox, Form } from 'antd';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import useEndpoint from '../../auth/auth_endpoints';
import BackButton from '@components/BackButton';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

interface LoginProps {
    handleForgetPasssword: () => void;
    handleCreateAccount: () => void;
}

interface parmsQuery {
    fromPricing: string;
    amount: string;
    currency: string;
}

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const Login = ({ handleForgetPasssword, handleCreateAccount }: LoginProps) => {
    const query = useQuery();
    const [rememberMe, setRememberMe] = useState(false);
    const [loading, setLoading] = useState(false);
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [queryObject, setQueryObject] = useState<parmsQuery | null>(null);
    const [passwordVisible, setPasswordVisible] = useState<boolean>(false);

    useEffect(() => {
        const fromPricing = query.get('fromPricing') || '';
        const amount = query.get('amount') || '';
        const currency = query.get('currency') || '';

        if (fromPricing && amount && currency) {
            const params: parmsQuery = { fromPricing, amount, currency };
            setQueryObject(params);

            // Fetch content or perform some action with the query parameters
            console.log('Fetching content with:', params);

            // Clear the URL parameters
            navigate(
                {
                    pathname: window.location.pathname,
                    search: '',
                },
                { replace: true },
            );
        }
    }, [query, navigate]);

    // const onFinish = (values: any) => {
    //     // navigate('/home');
    //     const email = values.email;
    //     const password = values.password;
    //     const rememberMe = values.rememberMe;

    //     // check if all data is passed
    //     if (!email || !password) {
    //         toast.error('Please enter email and password');
    //         return;
    //     }

    //     function handleCallback() {
    //         const callback = params.get('callback');
    //         if (queryObject) {
    //             window.location.href = `/dashboard/pricing?amount=${queryObject.amount}&currency=${queryObject.currency}`;
    //         } else {
    //             if (callback) {
    //                 window.location.replace(callback);
    //             } else {
    //                 const userData = localStorage.getItem('user');
    //                 if (userData) {
    //                     const userDetails = JSON.parse(userData);

    //                     // if ( userDetails?.plan?.details !== undefined ){
    //                     //     window.location.href = '/dashboard/chat';
    //                     // }else {
    //                     //     window.location.href = '/dashboard/pricing';
    //                     // }
    //                     // window.location.href = '/home/dashboard';
    //                 }
    //             }
    //         }
    //     }

    //     setLoading(true);
    //     useEndpoint()
    //         .login({ email, password, rememberMe })
    //         .then((res: any) => {
    //             setLoading(false);
    //             if (res?.success) {
    //                 localStorage.setItem('token', res?.data?.token);
    //                 const { id, fullname, email, isVerified, plan } = res.data;
    //                 localStorage.setItem('user', JSON.stringify({ id, fullname, email, isVerified, plan }));
    //                 // console.log("Navigating to:", `/verify-otp?email=${encodeURIComponent(email)}`);
    //                 window.location.href = `/verify-otp?email=${encodeURIComponent(email)}`;
    //                 // handleCallback();
    //                 toast.success(res?.message);
    //             } else {
    //                 toast.error(res?.message);
    //             }
    //         });
    // };

    const onFinish = (values: any) => {
        const email = values.email;
        const password = values.password;
        const rememberMe = values.rememberMe;
    
        if (!email || !password) {
            toast.error('Please enter email and password');
            return;
        }
    
        setLoading(true);
        useEndpoint()
            .login({ email, password, rememberMe })
            .then((res: any) => {
                setLoading(false);
                if (res?.success) {
                    localStorage.setItem('token', res?.data?.token);
                    const { id, fullname, email, isVerified, plan } = res.data;
                    localStorage.setItem('user', JSON.stringify({ id, fullname, email, isVerified, plan }));
    
                    // Test with window.location.href
                    console.log("Navigating to:", `/verify-otp?email=${encodeURIComponent(email)}`);
                    window.location.href = `/verify-otp?email=${encodeURIComponent(email)}&token=${encodeURIComponent(res?.data?.token)}`;    
                    toast.success(res?.message);
                } else {
                    toast.error(res?.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
                toast.error('Login failed');
            });
    };
    
    const handleCheckboxChange = () => {

        
        setRememberMe(!rememberMe);
    };

    return (
        <div className="w-full">
            {/* Logo */}
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <div className="w-12 h-12 bg-[#E55109] rounded-xl flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                        </svg>
                    </div>
                    <span className="text-2xl font-bold text-gray-900">GMind Admin</span>
                </div>
            </div>

            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Sign In</h1>
                <p className="text-gray-600">Welcome back! Please enter your credentials to continue.</p>
            </div>

            <Form layout="vertical" onFinish={onFinish} initialValues={{ rememberMe }} className="space-y-6">
                <Form.Item
                    name={'email'}
                    label={<label className="text-sm font-semibold text-gray-700">Email Address</label>}
                    rules={[
                        {
                            message: 'Email is required',
                            required: true,
                        },
                        {
                            type: 'email',
                            message: 'Please enter a valid email',
                        },
                    ]}
                >
                    <input
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#E55109] focus:border-transparent outline-none transition-all"
                        type="email"
                        placeholder="admin@example.com"
                    />
                </Form.Item>
                <Form.Item
                    name={'password'}
                    label={<label className="text-sm font-semibold text-gray-700">Password</label>}
                    rules={[
                        {
                            message: 'Password is required',
                            required: true,
                        },
                    ]}
                >
                    <div className="relative">
                        <input
                            className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#E55109] focus:border-transparent outline-none transition-all"
                            type={passwordVisible ? 'text' : 'password'}
                            placeholder="Enter your password"
                        />
                        <button
                            type="button"
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            {passwordVisible ? <EyeOutlined className="text-lg" /> : <EyeInvisibleOutlined className="text-lg" />}
                        </button>
                    </div>
                </Form.Item>
                <div className="flex items-center justify-between">
                    <Checkbox 
                        checked={rememberMe} 
                        onChange={handleCheckboxChange}
                        className="text-sm text-gray-600"
                    >
                        <span className="text-gray-700">Remember me</span>
                    </Checkbox>
                </div>

                <button 
                    type="submit" 
                    disabled={loading}
                    className="w-full bg-[#E55109] hover:bg-[#d14808] text-white font-semibold py-3 px-6 rounded-lg transition-colors shadow-lg shadow-[#E55109]/30 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                    {loading ? (
                        <>
                            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Signing in...
                        </>
                    ) : (
                        'Sign In'
                    )}
                </button>

            </Form>

            {/* Divider */}
            <div className="relative my-8">
                <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                </div>
                <div className="relative flex justify-center text-sm">
                    <span className="px-4 bg-white text-gray-500">Need help?</span>
                </div>
            </div>

            {/* Footer */}
            <div className="text-center text-sm text-gray-600">
                Having trouble signing in?{' '}
                <a href="mailto:support@gmind.ai" className="text-[#E55109] hover:text-[#d14808] font-medium">
                    Contact Support
                </a>
            </div>
        </div>
    );
};

export default Login;
